import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Grid, Menu } from "semantic-ui-react";
import { toast } from "react-semantic-toasts";
import downloadFile from "js-file-download";

import TopNav from "../../common/containers/top-nav";
import InvoiceGridContainer from "../grid/index.container";
import StampWarningContainer from "../../stamp/warning/index.container";
import { EmailFeatureDetails, isFeatureActive } from "../../company/feature/helpers";
import { makePrivateApiCall } from "utilities/dist/api";
import { FintechExport } from "../../fintech/components/fintech-export";

const InvoicePageHome = () => {
    const { company } = useSelector(({ auth }) => ({
        company: auth.user.company,
    }));
    const hasEmailFeature = isFeatureActive(company, EmailFeatureDetails);
    const [showFintechModal, setShowFintechModal] = useState(false);

    const exportInvoicesForOnFleet = async () => {
        try {
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);

            const result = await makePrivateApiCall({
                url: "/invoice/export",
                method: "get",
                params: { date: yesterday },
            });
            if (result.data) {
                downloadFile(result.data, `invoices-onfleet-export-${Date.now()}.csv`);
                toast({
                    icon: "file",
                    type: "success",
                    title: (
                        <h4
                            data-cy="on_fleet_export_success_toast_title"
                            style={{ marginBottom: 0 }}
                        >
                            Download CSV
                        </h4>
                    ),
                    description: (
                        <span data-cy="on_fleet_export_success_toast_description">
                            Invoices exported successfully.
                        </span>
                    ),
                });
            } else {
                toast({
                    icon: "file",
                    type: "warning",
                    title: (
                        <h4
                            data-cy="on_fleet_export_warning_toast_title"
                            style={{ marginBottom: 0 }}
                        >
                            Download CSV
                        </h4>
                    ),
                    description: (
                        <span data-cy="on_fleet_export_warning_toast_description">
                            No invoices found for the specified date.
                        </span>
                    ),
                });
            }
        } catch (err) {
            toast({
                icon: "file",
                type: "error",
                title: `Download CSV`,
                description: `Error occurred while generating CSV`,
            });
        }
    };

    return (
        <Grid>
            <TopNav
                headerIcon="newspaper"
                headerContent="Invoices"
                subheader="All your past invoices"
                extraButtons={() => (
                    <>
                        <Menu.Item
                            data-cy="add_new_invoice"
                            as={Link}
                            icon="plus"
                            name="New Invoice"
                            to="/invoice/create"
                        />
                        <Menu.Item
                            as={Link}
                            icon="external share"
                            name="OnFleet Export"
                            data-cy="on_fleet_export"
                            to="#"
                            onClick={() => exportInvoicesForOnFleet()}
                        />
                        <Menu.Item
                            data-cy="fintech_export"
                            as={Link}
                            icon="money"
                            name="Fintech Export"
                            to="#"
                            onClick={() => setShowFintechModal(true)}
                        />
                        {hasEmailFeature && (
                            <Menu.Item as={Link} icon="envelope" name="Email Log" to="/emails" />
                        )}
                    </>
                )}
            />

            <FintechExport
                open={showFintechModal}
                onClose={() => setShowFintechModal(false)}
                company={company}
            />

            <Grid.Column mobile={16}>
                <StampWarningContainer />
                <InvoiceGridContainer />
            </Grid.Column>
        </Grid>
    );
};

export default InvoicePageHome;
